import { parseColor, RGBtoCSS, type Color } from "vuetify/lib/util/colorUtils.mjs"

export function conditionColor(condition: GeneralCondition) {
  switch (condition) {
    case GeneralCondition.GOOD:
      return "success"
    case GeneralCondition.SUFFICIENT:
      return "warning"
    case GeneralCondition.INSUFFICIENT:
      return "yellow-darken-4"
    case GeneralCondition.BAD:
      return "error"
    default:
      return "grey"
  }
}

export function riskProfileColor(riskProfile?: RiskProfile) {
  switch (riskProfile) {
    case RiskProfile.LOW:
      return "success"
    case RiskProfile.MEDIUM:
      return "orange"
    case RiskProfile.HIGH:
      return "red"
    case RiskProfile.VERY_HIGH:
      return "error"
    default:
      return "grey"
  }
}

export function userRoleColor(role: string) {
  switch (role) {
    case "SUPER_ADMIN":
      return "admin"
    case "IMPERSONATED":
      return "admin"
    case "API":
      return "tertiary"
    case "USER":
      return "primary"
    case "SUPPLIER":
      return "green-darken-2"
    case "SUPPLIER_MANAGER":
      return "red"
    case "SUPPLIER_MECHANIC":
      return "orange"
    case "SUPPLIER_PLANNER":
      return "green-darken-2"
    default:
      return "grey"
  }
}

export function brlValueColor(value: BrlValue) {
  switch (value) {
    case BrlValue.GOOD:
      return "success"
    case BrlValue.DECENT:
      return "warning"
    case BrlValue.BAD:
      return "error"
    case BrlValue.REPLACED:
      return "secondary"
    case BrlValue.NA:
      return "primary"
    default:
      return "grey"
  }
}

export function riskScoreColor(value: "low" | "medium" | "high" | "critical") {
  switch (value) {
    case "low":
      return "amber"
    case "medium":
      return "amber-darken-2"
    case "high":
      return "deep-orange-lighten-2"
    case "critical":
      return "red"
    default:
      return "grey"
  }
}

export const getContractStatusColor = (status: ContractStatus) => {
  switch (status) {
    case ContractStatus.APPROVED:
      return "success"

    case ContractStatus.AWAITING_START_DATE:
    case ContractStatus.AWAITING_APPROVAL:
    case ContractStatus.PARTIALLY_APPROVED:
      return "warning"

    case ContractStatus.EXPIRED:
    case ContractStatus.NO_ACTIVE_PRICE_LISTS:
    case ContractStatus.MANUALLY_ENDED:
    case ContractStatus.INVALID_FOR_TICKET:
      return "grey"

    case ContractStatus.DENIED:
      return "error"
  }
}

export const getPriceListStatusColor = (status: PriceListStatus) => {
  switch (status) {
    case PriceListStatus.APPROVED:
      return "success"

    case PriceListStatus.AWAITING_START_DATE:
    case PriceListStatus.AWAITING_APPROVAL:
      return "warning"

    case PriceListStatus.EXPIRED:
    case PriceListStatus.MANUALLY_ENDED:
    case PriceListStatus.INVALID_FOR_TICKET:
      return "grey"

    case PriceListStatus.DENIED:
      return "error"
  }
}

export const getColorForTicketType = (ticketType: TicketType | "MUTATION"): string => {
  switch (ticketType) {
    case TicketType.ACTION:
      return "action"
    case TicketType.MALFUNCTION:
      return "malfunction"
    case TicketType.INSPECTION:
      return "inspection"
    case TicketType.NEN1010:
      return "nen1010"
    case TicketType.NEN3140:
      return "nen3140"
    // Sometimes mutation will be put with the ticket types
    case "MUTATION":
      return "primary"
    // Don't throw big error if a ticket type isn't recognized, just log an error and return a gray color
    default:
      console.error(`${ticketType} not recognised`)
      return "tonal"
  }
}

/**
 * Parse Vuetify Color to a CSS string
 * @param color
 * @returns
 */
export const parseColorToCSS = (color?: Color): string => {
  if (!color) return ""

  // Normalized the Color to an RGB
  const RGB = parseColor(color)

  // return the string
  return RGBtoCSS(RGB)
}
